import { createFileRoute } from "@tanstack/react-router";
import { SupportCaseDetailPage } from "@charphq/ui/components/layout/pages/SupportCaseDetailPage";

// `support_` (trailing underscore) keeps this detail route out of the /support
// page's layout — same convention as customers_.$customerId.
export const Route = createFileRoute("/support_/cases/$caseId")({
  component: SupportCaseDetailComponent,
});

function SupportCaseDetailComponent() {
  const { caseId } = Route.useParams();
  return <SupportCaseDetailPage caseId={caseId} />;
}
